// Home dashboard (Soft Bento) — self-contained localisation, same pattern as
// safetyhub/hubStrings.js. English fallback for any missing key.
import { useTranslation } from 'react-i18next';

const D = {
  en: {
    valueStatement: 'Your local guide to businesses, events and community life.',
    discover: 'Discover', discoverSub: 'Local businesses & services near you',
    communityHub: 'Community Hub', communityHubSub: 'Alerts, help, lost & found, marketplace & local news',
    safetyHub: 'Community Hub', safetyHubSub: 'Alerts, help, lost & found, marketplace & local news',
    events: 'Events', eventsSub: "What's on nearby",
    offers: 'Offers', offersSub: 'Deals from local businesses',
    favourites: 'My Favourites', favouritesSub: 'Your saved places',
    profile: 'My Profile', profileSub: 'Account & settings',
    activeIncidents: 'active incident', activeIncidentsPlural: 'active incidents',
    forBusinesses: 'For Businesses',
    businessSignUp: 'Business Sign Up',
    emergencyNumbers: 'Emergency Numbers', emergencyNumbersSub: 'Police, medical, fire — 112',
  },
  es: {
    valueStatement: 'Tu guía local de negocios, eventos y vida comunitaria.',
    discover: 'Descubrir', discoverSub: 'Negocios y servicios locales cerca de ti',
    communityHub: 'Centro Comunitario', communityHubSub: 'Avisos, ayuda, objetos perdidos, mercado y noticias locales',
    safetyHub: 'Centro Comunitario', safetyHubSub: 'Avisos, ayuda, objetos perdidos, mercado y noticias locales',
    events: 'Eventos', eventsSub: 'Qué hay cerca de ti',
    offers: 'Ofertas', offersSub: 'Descuentos de negocios locales',
    favourites: 'Mis Favoritos', favouritesSub: 'Tus lugares guardados',
    profile: 'Mi Perfil', profileSub: 'Cuenta y ajustes',
    activeIncidents: 'incidente activo', activeIncidentsPlural: 'incidentes activos',
    forBusinesses: 'Para Negocios',
    businessSignUp: 'Alta de negocio',
    emergencyNumbers: 'Teléfonos de emergencia', emergencyNumbersSub: 'Policía, médico, bomberos — 112',
  },
  de: {
    valueStatement: 'Dein lokaler Guide für Geschäfte, Events und Community-Sicherheit.',
    discover: 'Entdecken', discoverSub: 'Lokale Geschäfte & Services in deiner Nähe',
    safetyHub: 'Community-Sicherheitszentrum', safetyHubSub: 'Offizielle Warnungen, Vorfälle & Nachbarschaftshilfe',
    events: 'Events', eventsSub: 'Was in der Nähe los ist',
    offers: 'Angebote', offersSub: 'Deals lokaler Geschäfte',
    favourites: 'Meine Favoriten', favouritesSub: 'Deine gespeicherten Orte',
    profile: 'Mein Profil', profileSub: 'Konto & Einstellungen',
    activeIncidents: 'aktiver Vorfall', activeIncidentsPlural: 'aktive Vorfälle',
    forBusinesses: 'Für Unternehmen',
    businessSignUp: 'Unternehmen registrieren',
    emergencyNumbers: 'Notrufnummern', emergencyNumbersSub: 'Polizei, Notarzt, Feuerwehr — 112',
  },
  fr: {
    valueStatement: 'Votre guide local des commerces, événements et sécurité communautaire.',
    discover: 'Découvrir', discoverSub: 'Commerces et services locaux près de chez vous',
    safetyHub: 'Centre de sécurité communautaire', safetyHubSub: 'Alertes officielles, incidents et entraide',
    events: 'Événements', eventsSub: 'Ce qui se passe près de vous',
    offers: 'Offres', offersSub: 'Bons plans des commerces locaux',
    favourites: 'Mes Favoris', favouritesSub: 'Vos lieux enregistrés',
    profile: 'Mon Profil', profileSub: 'Compte et réglages',
    activeIncidents: 'incident actif', activeIncidentsPlural: 'incidents actifs',
    forBusinesses: 'Pour les entreprises',
    businessSignUp: 'Inscrire une entreprise',
    emergencyNumbers: "Numéros d'urgence", emergencyNumbersSub: 'Police, médical, pompiers — 112',
  },
  nl: {
    valueStatement: 'Jouw lokale gids voor bedrijven, evenementen en buurtveiligheid.',
    discover: 'Ontdekken', discoverSub: 'Lokale bedrijven en diensten bij jou in de buurt',
    safetyHub: 'Community-veiligheidshub', safetyHubSub: 'Officiële meldingen, incidenten en burenhulp',
    events: 'Evenementen', eventsSub: 'Wat is er te doen',
    offers: 'Aanbiedingen', offersSub: 'Deals van lokale bedrijven',
    favourites: 'Mijn Favorieten', favouritesSub: 'Jouw opgeslagen plekken',
    profile: 'Mijn Profiel', profileSub: 'Account en instellingen',
    activeIncidents: 'actief incident', activeIncidentsPlural: 'actieve incidenten',
    forBusinesses: 'Voor bedrijven',
    businessSignUp: 'Bedrijf aanmelden',
    emergencyNumbers: 'Noodnummers', emergencyNumbersSub: 'Politie, medisch, brandweer — 112',
  },
  ar: {
    valueStatement: 'دليلك المحلي للأعمال والفعاليات وسلامة المجتمع.',
    discover: 'استكشف', discoverSub: 'أعمال وخدمات محلية بالقرب منك',
    safetyHub: 'مركز سلامة المجتمع', safetyHubSub: 'تنبيهات رسمية وحوادث ومساعدة الجيران',
    events: 'فعاليات', eventsSub: 'ما يحدث بالقرب منك',
    offers: 'عروض', offersSub: 'عروض من الأعمال المحلية',
    favourites: 'مفضلاتي', favouritesSub: 'أماكنك المحفوظة',
    profile: 'ملفي الشخصي', profileSub: 'الحساب والإعدادات',
    activeIncidents: 'حادث نشط', activeIncidentsPlural: 'حوادث نشطة',
    forBusinesses: 'للأعمال',
    businessSignUp: 'تسجيل عمل تجاري',
    emergencyNumbers: 'أرقام الطوارئ', emergencyNumbersSub: 'الشرطة، الطبية، الإطفاء — 112',
  },
};

export function useDashT() {
  const { i18n } = useTranslation();
  const lang = (i18n.language || 'en').slice(0, 2);
  const dict = D[lang] || D.en;
  return (key) => dict[key] ?? D.en[key] ?? key;
}

export default useDashT;
